module.exports = __webpack_public_path__ + "static/media/YF80_1.15cf7861.jpg";